import gql from 'graphql-tag';

const GET_FEATURE_FLAG = gql`
  query getFeatureFlag($featureName: String!) {
    getFeatureFlag(query: { featureName: $featureName })
  }
`;

export default GET_FEATURE_FLAG;
